import {FaCheckCircle} from "react-icons/fa";
import {FaCircleXmark} from "react-icons/fa6";

import {TooltipWrapper} from "@/components/overlay/TooltipWrapper.tsx";
import {Plan} from "@/lib/types/billing.ts";

import css from "./PlanRow.module.css";

export interface PlanRowUproProps {
  plan: Plan;
}

export const PlanRowUpro = ({plan}: PlanRowUproProps) => {
  return (
    <TooltipWrapper toolTip="Utilize our Uptime.com experts to setup your monitoring for you at a competitive rate! Contact us to learn more!">
      <div className={css.PlanRowHeader}>
        <div className="py-2">
          {plan === Plan.Starter ? <FaCircleXmark className="pulse-color-gray-400" /> : <FaCheckCircle />}
        </div>
        <div className="w-100 text-center">
          <small className="fw-light">UPro! Services Available</small>
        </div>
      </div>
    </TooltipWrapper>
  );
};
